import { render, staticRenderFns } from "./order-details-item.vue?vue&type=template&id=dd77bbf4&scoped=true"
import script from "./order-details-item.vue?vue&type=script&lang=js"
export * from "./order-details-item.vue?vue&type=script&lang=js"
import style0 from "./order-details-item.vue?vue&type=style&index=0&id=dd77bbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd77bbf4",
  null
  
)

export default component.exports